import type { FC, SVGProps } from 'react';

export const SunIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="4.25"
        strokeWidth="1.5"
        stroke="currentColor"
      />
      <g strokeWidth="1.5" stroke="currentColor" strokeLinecap="round">
        <path d="M12 2.75v2" />
        <path d="M12 19.25v2" />
        <path d="M21.25 12h-2" />
        <path d="M4.75 12h-2" />
        <path d="M18.54 5.46l-1.41 1.41" />
        <path d="M6.87 17.13l-1.41 1.41" />
        <path d="M18.54 18.54l-1.41-1.41" />
        <path d="M6.87 6.87L5.46 5.46" />
      </g>
    </svg>
  );
};
